// this gets its own file to prevent circular imports in selectors.js
import { singlePropReducer } from '../../utils/reducers';

export const initialState = {
	thngId: undefined,
	productId: undefined,
	product: undefined,
	digimarcTape: undefined,
	hasCameraPermission: true,
	qrScanAuthResult: undefined,
	isLoading: false,
	isToastOpen: false,
};

const reducers = {
	clearSession(state) {
		state = initialState;
	},
	'validateQr/pending': (state) => {
		state.isLoading = true;
	},
	'validateQr/rejected': (state) => {
		state.isLoading = false;
	},
	setQrResults(state, { payload }) {
		state.qrScanAuthResult = payload;
		state.isLoading = false;
	},
	setIsLoading: singlePropReducer('isLoading'),
	setHasCameraPermission: singlePropReducer('hasCameraPermission'),
	setIsDigimarcCorrect: singlePropReducer('isDigimarcCorrect'),
	setToastOpen: singlePropReducer('isToastOpen'),
	setProduct: singlePropReducer('product'),
};

export default reducers;
